import * as React from "react";
import { DATASHEET_DEFAULT_FIELDS_DIMENSIONS } from "@modules/datasheets/components/editor/editor.constants";
import { IDatasheetEditorElement } from "../../datasheet.types";
import { useDatasheetElementController } from "../../hooks/datasheet-element.controller";
import { DatasheetFieldComponentHeadingPosition } from "@common/dto/datasheet/field-component/heading-position";
import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { DatasheetElement } from "@modules/datasheets/types/datasheet-element";

export type TextFieldProps = IDatasheetEditorElement<DatasheetFieldComponentGetDto> & {
  onTabOrderChange: (datasheetElement: DatasheetElement<DatasheetFieldComponentGetDto>) => void;
};

export const useTextFieldController = (props: TextFieldProps) => {
  const { 
    datasheetElement, 
    containerRef, 
    isSelected, 
    onSelect, 
    onCoordinatesChange, 
    datasheetGridSettings, 
    onResize, 
    multipleElementsSelected,
    resizeHandlerStrategy,
    isTabOrderSettingActive,
    onTabOrderChange,
  } = props;

  const datasheetElementController = useDatasheetElementController({
    isTabOrderSettingActive,
    resizeHandlerStrategy,
    datasheetElement,
    containerRef: containerRef,
    minWidth: DATASHEET_DEFAULT_FIELDS_DIMENSIONS[datasheetElement.original.field.fieldtype.typeid].width,
    minHeight: DATASHEET_DEFAULT_FIELDS_DIMENSIONS[datasheetElement.original.field.fieldtype.typeid].height,
    isSelected,
    onSelect,
    onCoordinatesChange,
    onResize,
    datasheetGridSettings,
    multipleElementsSelected,
  });

  const headingReference = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    datasheetElementController.handleHeadingSizeChange({
      width: headingReference.current?.offsetWidth || 0,
      height: headingReference.current?.offsetHeight || 0,
    });
  }, [
    datasheetElement.original.headtext,
    datasheetElement.original.headfontsize,
    datasheetElement.original.headfont,
    datasheetElement.original.headdisplay,
    datasheetElement.original.headpos,
  ]);

  const headingPosition = datasheetElement.original.headpos;
  const headingPlacedHorizontally = [
    DatasheetFieldComponentHeadingPosition.left, 
    DatasheetFieldComponentHeadingPosition.right
  ].includes(headingPosition);

  const handleTabOrderChange = React.useCallback(() => {
    onTabOrderChange(datasheetElement);
  }, [onTabOrderChange, datasheetElement]);


  return {
    headingReference,
    headingPlacedHorizontally,
    headingPosition,
    handleTabOrderChange,
    ...datasheetElementController,
  };
};